import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper, Tooltip } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExportIcon } from '../../styles';
import { StyledIconButton } from '../toggles/shared-styles';
import { copyChartToClipboard } from './utils';

interface ChartExportProps {
  chartRef: React.RefObject<HTMLElement>;
}

export const ChartExport = (props: ChartExportProps) => {
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const { chartRef } = props;
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setShowMenu((prevShowMenu) => !prevShowMenu);
  };

  return (
    <>
      <Tooltip title={t('common:commonValues.tooltips.chartExport')} placement="top">
        <StyledIconButton
          onClick={handleClick}
          size="small"
          aria-label="Export Chart"
          className="intercom__export_chart"
          ref={anchorRef}
        >
          <ExportIcon />
        </StyledIconButton>
      </Tooltip>
      <ChartExportMenuPopup
        chartRef={chartRef}
        open={showMenu}
        onClose={() => setShowMenu(false)}
        anchorEl={anchorRef.current}
      />
    </>
  );
};

interface ChartExportMenuPopupProps {
  open: boolean;
  onClose: () => void;
  chartRef: React.RefObject<HTMLElement>;
  anchorEl: HTMLElement | null;
}

const ChartExportMenuPopup = (props: ChartExportMenuPopupProps) => {
  const { open, onClose, chartRef, anchorEl } = props;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  return (
    <Popper open={open} placement="bottom-end" anchorEl={anchorEl} transition disablePortal style={{ zIndex: 999 }}>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper style={{ zIndex: 999 }}>
            <ClickAwayListener onClickAway={onClose}>
              <MenuList>
                <MenuItem
                  onClick={() => {
                    copyChartToClipboard(chartRef, () => {
                      enqueueSnackbar(t('common:snackbarMessages.chartCopiedToClipboard'), {
                        variant: 'success',
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'right',
                        },
                      });
                    });
                  }}
                >
                  {t('common:buttonsAndMenus.copyChartImage')}
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
